import { Injectable } from '@angular/core';


@Injectable()

export class JwtService {

  getToken(): String {
    return window.localStorage['userToken'];
  }

  getType():String{
    return window.localStorage['userType'];
  }

  saveTokenOrType(token: String,type: String) {
    window.localStorage['userToken'] = token;
    window.localStorage['userType'] = type;
  }

  destroyTokenOrType() {
    window.localStorage.removeItem('userToken');
    window.localStorage.removeItem('userType');
  }

}
